$(".header__burger").click(function() {
    $("body").toggleClass("fixed-body")
    $(".header").toggleClass("header--active")
})